import axiosInstance from '@/utils/api.js'

var state = {
  ipGroups: []
}

var getters = {
  IP_GROUPS: (state) => {
    return state.ipGroups
  }
}

var mutations = {
  SET_IP_GROUPS: (state, payload) => {
    state.ipGroups = payload
  }
}

var actions = {
  GET_IP_GROUPS: async (context, payload) => {
    let result = await axiosInstance.get('/users/ip_groups')
    if (result.status === 200) {
      context.commit('SET_IP_GROUPS', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/ipGroups.js